export default __webpack_public_path__ + "static/GLP-96b12aa556614dd5791fcc9b5d347459.png";